import Component from "./JumbotronLeaderboard";

export default Component;
